import * as React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

import { Container } from "@mui/system";

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
  palette: {
    primary: {
      main: "#fff",
    },
  },
  typography: {
    fontFamily: "IRANSansXFaNum",
  },
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});
const myStyle = {
  backgroundImage: "url('/images/bg.jpg')",
  height: "100vh",
  width: "100vw",
  color: "#fff",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  display: "flex",
};
const LayoutIndex = ({ children }) => {
  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
        <div style={myStyle} dir="rtl">
          <Container>{children}</Container>
        </div>
      </ThemeProvider>
    </CacheProvider>
  );
};
export default LayoutIndex;
